// @flow
import { get } from '../../utils/fetch'

export const getLatest = (perpage = 20, page = 1) => {
  const latest = get(`/feed/latest?per_page=${perpage}&page=${page}`)
  return latest
}

export const getFeatured = (perpage = 20, page = 1) => {
  const featured = get(`/feed/featured?perpage=${perpage}&page=${page}`)
  return featured
}
